import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import MobileStickyBooking from "./components/MobileStickyBooking";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import TeamPage from "./pages/TeamPage";
import GalleryPage from "./pages/GalleryPage";
import ClientelePage from "./pages/ClientelePage";
import BookingPage from "./pages/BookingPage";
import ManageBookingPage from "./pages/ManageBookingPage";
import ContactPage from "./pages/ContactPage";
import AdminClientelePage from "./pages/AdminClientelePage";
import ReviewsSchemaInjector from "./components/ReviewsSchemaInjector";
import ErrorBoundary from "./components/ErrorBoundary";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Admin surface + Gallery are full-screen experiences — hide footer + mobile sticky.
// Booking page already has the reservation flow inline — hide the floating CTA.
function ConditionalChrome() {
  const { pathname } = useLocation();
  const isImmersive =
    pathname === "/gallery" || pathname.startsWith("/admin");
  const isBooking = pathname.startsWith("/booking");
  if (isImmersive) return null;
  return (
    <>
      <Footer />
      {!isBooking && <MobileStickyBooking />}
    </>
  );
}

function ConditionalNav() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <Navigation />;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App texture-grain">
        <BrowserRouter>
          <ScrollToTop />
          <ReviewsSchemaInjector />
          <ConditionalNav />
          <main>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/cercle" element={<ClientelePage />} />
                {/* Legacy URL — redirect old links to the new slug so
                    bookmarks and existing Google results keep working. */}
                <Route path="/clientele" element={<Navigate to="/cercle" replace />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/booking/manage" element={<ManageBookingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin/clientele" element={<AdminClientelePage />} />
              </Routes>
            </ErrorBoundary>
          </main>
          <ConditionalChrome />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
